import { render, staticRenderFns } from "./TopluGenelTalepGonderIslemDetayView.vue?vue&type=template&id=046b0539&scoped=true"
import script from "./TopluGenelTalepGonderIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./TopluGenelTalepGonderIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046b0539",
  null
  
)

export default component.exports